import { useNavigate } from 'react-router-dom';

import { NETWORK_ERROR_GEO } from 'consts';
import { useErrorScreenContext } from 'context/error/error';
import { playoutStoreDataResolver } from 'utils';

export const useSetGeoError = () => {
  const navigate = useNavigate();
  const { setError } = useErrorScreenContext();
  const { geoBlockingProperties } = playoutStoreDataResolver();

  return () => {
    setError({
      error: {
        titleId: `Errors.Api.${NETWORK_ERROR_GEO}`,
        titleDefault: geoBlockingProperties?.name || 'Content Cannot Be Played',
        messageId: `Errors.Api.${NETWORK_ERROR_GEO}.description`,
        messageDefault:
          geoBlockingProperties?.description || 'The content  you  requested is not available in you country',
        code: NETWORK_ERROR_GEO,
      },
      goBackButton: {
        goBackLink: () => {
          navigate(-1);
        },
        translationId: 'GeoError.playerButtonText',
        defaultMessage: 'Go Back',
      },
    });
  };
};
